import React, { memo } from "react";
import PropTypes from "prop-types";
// import { styled } from "@acko-tech/building-blocks.ui.common";

import CloseCross from '@public/images/close-cross.svg';

// const CloseButtonWrapper = styled.div`
//   position: absolute;
//   right: 0;
//   ${props => (props.setTopHeight ? `top: 0px` : "")};
//   ${props => props.styles}
// `;

// const Wrapper = styled.div`
//   display: flex;
//   width: 100%;
//   position: relative;
//   ${(props: { align?: string }) =>
//     props.align === "center" && "justify-content: center"};
//   align-items: center;
//   ${props => props.styles}
// `;

function ModalHeader(props: HeaderProps): JSX.Element {
  const {
    header,
    closeButton,
    onClick,
    // align,
    // hideTopPadding,
    closeButtonStyles,
    headerStyles
  } = props;

  return (
    <div
      className="flex relative w-full items-center"
      style={headerStyles}
    >
      {header}
      {closeButton && (
        <div
          className="absolute right-0 top-0"
          style={closeButtonStyles}
          onClick={onClick}
        >
          <CloseCross />
        </div>
      )}
    </div>
  );
}

interface HeaderProps {
  header: JSX.Element | undefined;
  closeButton: boolean;
  onClick(): void;
  align?: string;
  hideTopPadding?: boolean;
  closeButtonStyles?: any;
  headerWrapperStyles?: any;
  headerStyles?: any;
}

ModalHeader.propTypes = {
  closeButton: PropTypes.bool,
  onClick: PropTypes.func,
  header: PropTypes.node,
  align: PropTypes.string
};

ModalHeader.defaultProps = {
  closeButton: false,
  onClick: () => null,
  header: <div />,
  align: ""
};

export default memo(ModalHeader);
